import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { localized, msg, str } from '@lit/localize';
import style from "./skip-links.scss";


/**
 * Tab navigation accessible "navigate to" links. The targets are main landmarks: `menu-top`, `menu-left` and `main`.
 * If some of the landmarks are missing, the corresponding link is not rendered.
 */
@customElement('skip-links')
@localized()
export class SkipLinks extends LitElement {
    static override styles = style;

    @state() private menuTopId = '';
    @state() private menuLeftId = '';
    @state() private mainId = '';

    override render() {
        return html`
            <nav id="navskipper" aria-label=${msg(str`Szybka nawigacja`)}>
                <ul>
                    ${when(this.menuTopId, () => html`
                        <li><a href='#${this.menuTopId}'>${msg(str`Przejdź do menu głównego`)}</a></li>
                    `)}
                    ${when(this.menuLeftId, () => html`
                        <li><a href='#${this.menuLeftId}'>${msg(str`Przejdź do podmenu`)}</a></li>
                    `)}
                    ${when(this.mainId, () => html`
                        <li><a href='#${this.mainId}'>${msg(str`Przejdź do treści`)}</a></li>
                    `)}
                </ul>
            </nav>
        `;
    }

    override updated() {
        ['menu-top', 'menu-left', 'main'].forEach(tag => {
            const elem = document.querySelector(tag);
            if (elem?.id == '') elem.id = 'ui-skip-target-' + tag;
        });
        const main = document.querySelector('main');
        if (main) main.tabIndex = -1;
        this.menuTopId = document.querySelector('menu-top')?.id ?? '';
        this.menuLeftId = document.querySelector('menu-left')?.id ?? '';
        this.mainId = main?.id ?? '';
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "skip-links": SkipLinks,
    }
}
